import { Injectable } from '@angular/core';

import { HttpStatusCode } from '@nano/common/http';
import { NavService } from '@nano/common/nav';
import { ErrorService } from '@nano/core/error';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserVerified {
  constructor(
    private navService: NavService,
    private errorService: ErrorService
  ) {}

  isUserVerified(): Observable<boolean> {
    return this.navService.userVerified$.pipe(
      tap((verified) => {
        if (!verified) {
          this.errorService.navigateToErrorPage(HttpStatusCode.FORBIDDEN);
        }
      })
    );
  }

  canActivate(): Observable<boolean> {
    return this.isUserVerified();
  }

  canLoad(): Observable<boolean> {
    return this.isUserVerified();
  }
}
